import { Controller } from "@hotwired/stimulus"

/*
 * MobileMenuController — brutalist full-screen mobile navigation toggle.
 *
 * Expected data attributes on the host element:
 *   data-controller="mobile-menu"
 *
 * Toggle button:
 *   data-action="click->mobile-menu#toggle"
 *   data-mobile-menu-toggle-btn-target="_"
 *
 * Menu overlay:
 *   data-mobile-menu-menu-target="menu"
 *
 * Links inside the menu (auto-close after navigation):
 *   data-mobile-menu-link-target="link"
 */
export default class extends Controller {

  static targets = ["menu", "toggleBtn", "link"]
  static values = {
    openLabel: { type: String, default: "[ Close ]" },
    closedLabel: { type: String, default: "[ Menu ]" }
  }

  connect() {
    // Bind click on every nav link to close the menu
    this.linkTargets.forEach((link) => {
      link.addEventListener("click", () => this.close())
    })
  }

  toggle() {
    const menu = this.hasMenuTarget ? this.menuTarget : null
    const btn = this.hasToggleBtnTarget ? this.toggleBtnTarget : null

    if (menu == null) return

    const isHidden = menu.classList.contains("hidden")
    if (isHidden) {
      this.open(menu, btn)
    } else {
      this.close()
    }
  }

  open(menu, btn) {
    menu.classList.remove("hidden")
    menu.classList.add("flex")
    document.body.style.overflow = "hidden"
    if (btn) btn.textContent = this.openLabelValue
  }

  close() {
    if (this.hasMenuTarget) {
      this.menuTarget.classList.remove("flex")
      this.menuTarget.classList.add("hidden")
    }
    document.body.style.overflow = ""
    if (this.hasToggleBtnTarget) this.toggleBtnTarget.textContent = this.closedLabelValue
  }
}
